module.exports = ".container {\n  max-height: 100%;\n  min-height: 100%; }\n\n.spacer {\n  flex: 1 1 auto; }\n"